<ion-checkbox
  #checkbox
  color="primary"
  slot="start"
  [disabled]="disabled"
  [name]="name"
  [value]="value"
  [formControl]="control"
  (ionChange)="onCheckedChange()"
  labelPlacement="end">
  @if (text) {
    <div class="ion-text-wrap">{{ text }}</div>
  }
  @if (subtitle) {
    <div class="ion-text-wrap subtitle">{{ subtitle }}</div>
  }
  <div class="ion-text-wrap">
    <ng-content></ng-content>
  </div>
</ion-checkbox>

@if (showError && control?.errors && control?.touched) {
  <div class="error-wrapper">
    <c-validation-error [validationMessages]="control.errors" [controlValue]="control.value"> </c-validation-error>
  </div>
}
